import type { CardDesignTokens } from '@primeuix/themes/types/card';

/**
 * Card component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/card/index.ts
 *
 * Component documentation:
 * https://primeng.org/card
 */
export const cardComponentTokens: Partial<CardDesignTokens> = {
  root: {
    shadow: 'none',
  },
};
